import { useNavigate } from 'react-router-dom';
import { MenuCard } from '@runway/devkit';
import { FC } from 'react';

export const ADBAccessCard: FC = () => {
  const navigate = useNavigate();

  return (
    <MenuCard
      title="Request Access to Manage Interactive Clusters"
      subtitle="ADB Elevated Access Request"
      onButtonClick={() => navigate('/dataanalytics/adb-access')}
      buttonText="Request"
    />
  );
};
